var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vendor-profile-reviews"},[_c('vendor-reviews',{attrs:{"vendor":_vm.vendor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }